import { DemographicAnalyticsPayload } from '@mm/state/interfaces/botAnalytics';

import React, { ReactNode } from 'react';
import { calcPercentage } from '../../XRayAnalytics/XRayContactsByLandingPage/XRayContactsByLandingPage';
import styles from './DemographicBarChart.module.css';

type Props = {
  icon: ReactNode;
  title: string;

  data: DemographicAnalyticsPayload;
};

export const DemographicBarChart = ({ icon, title, data }: Props) => {
  const { total, records, hits } = data || {};

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {icon}
        {title}
      </div>

      {records?.map((label, index) => {
        const percentage = calcPercentage(total || 0, hits?.[index] || 0);
        return (
          <div key={label} className={styles.row}>
            <div className={styles.statsBarRow}>
              <div
                className={styles.statsBar}
                style={{ width: `${percentage}%` }}
              />
              <span>{label}</span>
            </div>
            <div className={styles.numbersRow}>
              <span className={styles.hits}>
                {hits?.[index]?.toLocaleString()}
              </span>
              <span className={styles.percentage}>{percentage}%</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
